import dayjs from "dayjs";

export type CanonicalQuickRangeKey =
	| "1w"
	| "2w"
	| "1m"
	| "2m"
	| "3m"
	| "6m"
	| "1y"
	| "2y";

type CanonicalQuickRangeDefinition = {
	label: string;
	amount: number;
	unit: "week" | "month" | "year";
	approxDays: number;
};

const RANGE_DEFINITIONS: Record<
	CanonicalQuickRangeKey,
	CanonicalQuickRangeDefinition
> = {
	"1w": { label: "1w", amount: 1, unit: "week", approxDays: 7 },
	"2w": { label: "2w", amount: 2, unit: "week", approxDays: 14 },
	"1m": { label: "1m", amount: 1, unit: "month", approxDays: 30 },
	"2m": { label: "2m", amount: 2, unit: "month", approxDays: 60 },
	"3m": { label: "3m", amount: 3, unit: "month", approxDays: 90 },
	"6m": { label: "6m", amount: 6, unit: "month", approxDays: 180 },
	"1y": { label: "1y", amount: 1, unit: "year", approxDays: 365 },
	"2y": { label: "2y", amount: 2, unit: "year", approxDays: 730 },
};

export const getQuickRangeLabel = (range: CanonicalQuickRangeKey) =>
	RANGE_DEFINITIONS[range].label;

export const getQuickRangeDays = (range: CanonicalQuickRangeKey) =>
	RANGE_DEFINITIONS[range].approxDays;

export const shiftDateByQuickRange = (
	range: CanonicalQuickRangeKey,
	end = new Date(),
) => {
	const def = RANGE_DEFINITIONS[range];
	return dayjs(end).subtract(def.amount, def.unit).toDate();
};

export const getMatchingQuickRange = (
	startDate: Date | null | undefined,
	endDate: Date | null | undefined,
	allowedRanges: readonly CanonicalQuickRangeKey[],
	toleranceDays = 5,
): CanonicalQuickRangeKey | "" => {
	if (!startDate || !endDate) return "";

	const days = dayjs(endDate)
		.startOf("day")
		.diff(dayjs(startDate).startOf("day"), "day");
	for (const range of allowedRanges) {
		if (Math.abs(days - RANGE_DEFINITIONS[range].approxDays) <= toleranceDays) {
			return range;
		}
	}

	return "";
};
